import React, { useMemo } from 'react';
import classNames from 'classnames';
import _ from 'underscore';
import { AdAssetsFormShimmer, AdAssetsPreviewerShimmer } from '@bingads-webui-campaign-react/pmax-lite-shimmers';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';

import { AssetsStepForm } from './assets-step-form';
import { getAssetsStepStyles } from './assets-step-styles';

export const AssetsStepShell = (props) => {
  const { data } = props || {};

  const isLoading = useMemo(() => _.isEmpty(data), [data]);
  const getStyles = useResponsiveStyles(getAssetsStepStyles);

  return (
    <>
      {
        isLoading ?
          <div className={classNames(getStyles('container'))}>

            <div className={classNames(getStyles('formContainer'))}>
              <AdAssetsFormShimmer />
            </div>
            <div className={classNames(getStyles('previewerContainer'))} style={{ marginTop: '150px' }}>
              <AdAssetsPreviewerShimmer />
            </div>
          </div>
          : <AssetsStepForm
              {...props}
          />
      }
    </>
  );
};
